<template>
    <div class="bg">
        <div class="success">
            <div class="successImg">
                <div class="tick">
                   <div class="successText">延时成功</div>
                </div>
            </div>
        </div>
        <div class="meetingInfo">
            <div class="meetingName">
                <div class="classify">会议室：第一会议室</div>
                <div class="classify">会议名称：会议预约</div>
                <div class="classify">参会人：王俊凯、易烊千玺、王源</div>
            </div>
            <div class="meetingTime">
                <div class="time">会议时间：2020.0.1(周一) 08：00-09：00</div>
                <div class="time">预定人：王源</div>
                <div class="time">延时：15分钟</div>
            </div>
        </div>
        <div class="complete">
            <div class="comButton" @click="comHandle">
                <div class="comText">完成</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data () {
        return {

        }
    },
    methods : {
        comHandle () {
            this.$router.push({path: '/homePage',})
        }
    }
}
</script>

<style lang="less" scoped>
.bg{
    width: 100%;
    height: 100%;
    background: url(../assets/delay-bg.png);
    .success{
        width: 13%;
        height: 50%;
        margin: 0 auto;
        .successImg{
            width: 240px;
            height: 240px;
            background: url(../assets/delay-yuan.png) no-repeat;
            position: relative;
            top: 25%;
            .tick{
               width: 100%;
               height: 100%;
               background: url(../assets/delay-gou.png) no-repeat;
               position: relative;
               top: 24%;
               left: 30%;
               .successText{
                   font-size: 36px;
                   color: #FFF000;
                   font-family: SimHei;
                   font-weight: bold;
                   background: linear-gradient(0deg, #1CF7E9 0%, #2AD8FF 100%);
                   -webkit-background-clip: text;
                   -webkit-text-fill-color: transparent;
                   position: relative;
                   top: 35%;
                   right: 9%;
               }
            }
        }
    }
    .meetingInfo{
        width: 100%;
        height: 35%;
        display: flex;
        .meetingName{
            width: 50%;
            height: 45%;
            .classify{
                width: 50%;
                height: 76%;
                text-align: left;
                font-size: 30px;
                color: #666666;
                font-family: SimHei;
                font-weight: 400;
                margin: 0 auto;
            }
        }
        .meetingTime{
            width: 50%;
            height: 45%;
            .time{
                width: 100%;
                height: 76%;
                text-align: left;
                font-size: 30px;
                color: #666666;
                font-family: SimHei;
                font-weight: 400;
            }
        }
    }
    .complete{
        width: 13%;
        height: 15%;
        margin: 0 auto;
        .comButton{
            width: 234px;
            height: 80px;
            background: linear-gradient(0deg, #1BF7E9, #2AD7FF);
            border-radius: 4px;
            .comText{
                font-size: 30px;
                color: #ffffff;
                text-align: center;
                line-height: 80px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/DelaySuccess.vue